// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"su_a bhn_a bhn_r bhn_j","Photos__img":"su_b bhn_b"};